import { useState, useEffect } from 'react'
import FirstLoginPasswordChange from './FirstLoginPasswordChange'
import { useAuth } from '../contexts/AuthContext'

const FirstLoginWrapper = ({ children }) => {
    const { user } = useAuth()
    const [showPasswordChange, setShowPasswordChange] = useState(false)

    useEffect(() => {
        // Check if user exists and requires password change
        if (user && user.requiresPasswordChange) {
            setShowPasswordChange(true)
        }
    }, [user])

    const handlePasswordChangeSuccess = () => {
        setShowPasswordChange(false)
        // Refresh the page to update the user context
        window.location.reload()
    }

    const handlePasswordChangeCancel = () => {
        // Logout the user if they cancel password change
        localStorage.removeItem('token')
        window.location.href = '/login'
    }

    // If user needs to change password, show the password change modal
    if (showPasswordChange) {
        return (
            <FirstLoginPasswordChange
                onSuccess={handlePasswordChangeSuccess}
                onCancel={handlePasswordChangeCancel}
            />
        )
    }

    // Otherwise, render the children normally
    return children
}

export default FirstLoginWrapper
